import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';
import { TITLE_LINE_HEIGHT } from './SectionTitle';

// The person's name on the public sharing page, with their role title directly
// underneath in slightly smaller text (nothing when there's no role). The name uses the
// same line height as the section titles so it lines up with the first one.
const ProfileNameHeading = ({ name, role, font }) => (
  <Box>
    <Heading
      as="h1"
      fontFamily={font}
      fontSize={{ base: '30px', md: '34px' }}
      fontWeight="700"
      lineHeight={TITLE_LINE_HEIGHT}
      letterSpacing="0"
    >
      {name}
    </Heading>
    {role?.trim() && (
      <Text
        fontFamily={font}
        fontSize={{ base: '17px', md: '19px' }}
        fontWeight="400"
        lineHeight="1.3"
        color="whiteAlpha.900"
        mt={2}
      >
        {role}
      </Text>
    )}
  </Box>
);

export default ProfileNameHeading;
